import { useTranslation } from "react-i18next";
import { SimpleTooltip } from "../../components/ui/tooltip/index.js";
import { cn } from "../../lib/utils.js";
import { useInboxUnreadConversationCount } from "./InboxRealtimeProvider.js";

/** Mint header pill: conversation unread count from InboxRealtimeProvider (C-7c). */
export function InboxUnreadConversationPill({
  narrow = false,
  className,
}: {
  /** Narrow list: show number only; full phrase in tooltip / aria-label. */
  narrow?: boolean;
  className?: string;
}): React.JSX.Element | null {
  const { t } = useTranslation();
  const count = useInboxUnreadConversationCount();
  if (count == null || count <= 0) {
    return null;
  }

  const full = t("inbox.unreadSummary.pill", { count });
  const aria = t("inbox.unreadSummary.aria", { count });
  const label = narrow ? String(count) : full;

  const pill = (
    <span
      className={cn(
        "inline-flex h-[22px] shrink-0 items-center rounded-full bg-brand-mint px-2 text-[0.71875rem] font-[600] whitespace-nowrap text-[#126c56] tabular-nums",
        className,
      )}
      aria-label={aria}
      data-testid="inbox-unread-conversation-pill"
    >
      {label}
    </span>
  );

  return narrow ? <SimpleTooltip content={full}>{pill}</SimpleTooltip> : pill;
}
